import { render, staticRenderFns } from "./Chalet.vue?vue&type=template&id=367846f4&"
import script from "./Chalet.vue?vue&type=script&lang=js&"
export * from "./Chalet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports